import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TableSortLabel,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as EditIcon } from "../../Assets/Icons/PharmsmartIcon/EditIcon.svg";
import { ReactComponent as DeleteIcon } from "../../Assets/Icons/PharmsmartIcon/DeleteIcon.svg";
import "../../Sass/Common.scss";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
import TableEmptyState from "../../Components/Common/Table/TableEmptyState";
import TableLoadMore from "../../Components/Common/Table/TableLoadMore";
import TableCellLoader from "../../Components/Common/Table/TableCellLoader";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";

const useStyle = makeStyles((theme) => ({
  tableHeight: {
    "&>tr": {
      "&>td": {
        whiteSpace: "nowrap !important",
        lineHeight: "35px !important",
      },
    },
  },
  addressCell: {
    whiteSpace: "nowrap",
  },
  tableHead: {
    "&>tr": {
      "&>th": {
        whiteSpace: "nowrap !important",
        "&:first-child": {
          width: "18%",
        },
        "&:nth-child(2)": {
          width: "30%",
        },
        "&:nth-child(3)": {
          width: "46%",
        },
        "&:last-child": {
          width: "0% !important",
        },
      },
    },
  },
  name: {
    color: "#464646 !important",
  },
  hoverAlign: {
    padding: "10px 6px !important",
  },
}));

const PharmacyTable = ({
  pharmaciesList,
  loginUserDetail,
  columnSortingOrder,
  setColumnSortingOrder,
  showCreateAndAction,
  setPharmacyRecordActionType,
  setEditPharmacyData,
  setAddPharmacy,
  setDeletePharmacy,
  setDeleteId,
  setPatientCount,
  setTarget,
  tableCells,
}) => {
  const classes = useStyle();
  const defaultColumnOrderBy = "asc";
  const showLoaderValue = Object.values(tableCells).filter((item) => {
    return item;
  });

  return (
    <>
      <TableContainer>
        <Table stickyHeader>
          <TableHead
            className={classes.tableHead}
            sx={{
              "&>tr": {
                "&>th": {
                  "&:nth-child(3)": {
                    width:
                      ["admin", "super_admin"].indexOf(
                        loginUserDetail?.data?.data?.role
                      ) !== -1
                        ? "46%"
                        : "10%",
                  },
                },
              },
            }}
          >
            <TableRow>
              {Object.keys(tableCells).map((headCell) => (
                <>
                  {tableCells[headCell].show && (
                    <>
                      {tableCells[headCell].sortable === true ? (
                        <TableCell
                          key={tableCells[headCell].id}
                          align="center"
                          padding={
                            tableCells[headCell].disablePadding
                              ? "none"
                              : "normal"
                          }
                        >
                          <TableSortLabel
                            sx={{
                              "&.MuiTableSortLabel-root": {
                                color: "white",
                              },
                              "& .MuiTableSortLabel-icon": {
                                color:
                                  columnSortingOrder.orderBy ===
                                  tableCells[headCell].id
                                    ? "#525252 !important"
                                    : "#C5C5C5 !important",
                                "&.MuiTableSortLabel-iconDirectionDesc": {
                                  color: "#525252 !important",
                                },
                                "& .MuiTableSortLabel-iconDirectionAsc": {
                                  color:
                                    columnSortingOrder.orderBy ===
                                    tableCells[headCell].id
                                      ? "#525252 !important"
                                      : "#C5C5C5 !important",
                                },
                              },
                            }}
                            className="tableSort"
                            direction={
                              columnSortingOrder.orderBy ===
                              tableCells[headCell].id
                                ? columnSortingOrder.sortBy
                                : defaultColumnOrderBy
                            }
                            onClick={(e) => {
                              setColumnSortingOrder({
                                orderBy: tableCells[headCell].id,
                                sortBy:
                                  (columnSortingOrder.orderBy ===
                                  tableCells[headCell].id
                                    ? columnSortingOrder.sortBy
                                    : defaultColumnOrderBy) === "desc"
                                    ? "asc"
                                    : "desc",
                              });
                            }}
                          >
                            {tableCells[headCell].label}
                          </TableSortLabel>
                        </TableCell>
                      ) : (
                        <>
                          {showCreateAndAction && (
                            <TableCell>{tableCells[headCell].label}</TableCell>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableHeight}>
            {pharmaciesList?.loading ? (
              <TableCellLoader
                cells={
                  showLoaderValue.filter(({ show }) => show === true).length
                }
              />
            ) : pharmaciesList?.data?.list?.length > 0 ? (
              pharmaciesList?.data?.list?.map((item, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell semiBold className={classes.name}>
                      {" "}
                      {item?.name}{" "}
                    </TableCell>
                    {Object.keys(tableCells).map((columnName) => {
                      return (
                        <>
                          {tableCells[columnName].show && (
                            <>
                              {columnName === "email" && (
                                <TableCell>{item?.email}</TableCell>
                              )}
                              {columnName === "address" && (
                                <TableCell className={classes.addressCell}>
                                  {item?.address || "N / A"}
                                </TableCell>
                              )}
                            </>
                          )}
                        </>
                      );
                    })}
                    {showCreateAndAction && (
                      <TableCell>
                        <Box
                          display={"flex"}
                          fontWeight="300"
                          alignItems="center"
                          justifyContent="space-evenly"
                        >
                          <HtmlTooltipMain title="Edit Pharmacy">
                            <IconButton
                              className={classes.hoverAlign}
                              onClick={() => {
                                setPharmacyRecordActionType("editPharmacy");
                                setEditPharmacyData(item);
                                setAddPharmacy(true);
                              }}
                            >
                              <PrimaryIcon
                                color="primary"
                                height="19px"
                                icon={EditIcon}
                                cursor="pointer"
                              />
                            </IconButton>
                          </HtmlTooltipMain>
                          <HtmlTooltipMain title="Delete Pharmacy">
                            <IconButton
                              className={classes.hoverAlign}
                              onClick={() => {
                                setDeletePharmacy(true);
                                setDeleteId(item?.id);
                                setPatientCount(item?.patient_count);
                              }}
                            >
                              <PrimaryIcon
                                height="19px"
                                icon={DeleteIcon}
                                cursor="pointer"
                              />
                            </IconButton>
                          </HtmlTooltipMain>
                        </Box>
                      </TableCell>
                    )}
                  </TableRow>
                );
              })
            ) : (
              <TableEmptyState />
            )}
            {pharmaciesList?.data?.list?.length !=
              pharmaciesList?.data?.filterd_record && (
              <TableLoadMore setRef={setTarget} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default PharmacyTable;
